import React from 'react';
import clsx from 'clsx';
import { CircularProgress, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import HeaderMenu from '../header-menu';
import Footer from '../footer';
import CustomizedSnackbars from '../material-snackbars';
import { Overlay } from '../../styles/global';
import { Styles } from '../../styles/material-styles';

const useStyles = makeStyles(Styles);

export default function EmailSettingsLayout({
  children,
  loading = false,
  notification,
  closeNotification,
}) {
  const classes = useStyles();
  const headerMenu = useSelector(state => state.headerMenu);
  const actionsHeaderMenu = useSelector(state => state.actionsHeaderMenu);

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <main
        className={clsx(
          classes.content,
          { [classes.contentShift]: headerMenu.open },
          classes.actionsContent,
          { [classes.actionscontentShift]: actionsHeaderMenu.open }
        )}
      >
        <div className={classes.drawerHeader} />
        <Container
          component="main"
          maxWidth="xl"
          style={{
            width: '100%',
            maxWidth: '100%',
            paddingLeft: 0,
            marginLeft: 0,
          }}
        >
          {children}
        </Container>
      </main>

      {loading && (
        <Overlay>
          <CircularProgress color="secondary" />
        </Overlay>
      )}

      {notification && (
        <CustomizedSnackbars
          variant={notification.variant}
          message={notification.message}
          isOpen={notification.open}
          toClose={closeNotification}
        />
      )}
      <Footer />
    </div>
  );
}
